import {
  DELETE_INVITE,
  FETCH_TEAM_ASSOCIATES,
  FETCH_TEAM_ASSOCIATES_LOADING,
} from "../../actions/types";

const initialState = {
  // teamMembersDetails:[],
  // teamMembersDetailsLoading: false,
};

const teamMembersReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_TEAM_ASSOCIATES:
      return {
        ...state,
        teamMembersDetails: action.payload, // Update the state with the fetched data
      };
    case FETCH_TEAM_ASSOCIATES_LOADING:
      return {
        ...state,
        teamMembersDetailsLoading: action.payload, // Update the state with the fetched data
      };
    case DELETE_INVITE:
      return {
        ...state,
        deleteInvite: action.payload, // Update the state with the fetched data
      };
    default:
      return state;
  }
};

export default teamMembersReducer;
